interface SubRoute {
  active: {
    test: (path: string) => boolean;
  };
  noResultsTitle: string;
  noResultsMsg: string;
  noResultsImg: string;
}

interface NoResults {
  title: string;
  msg: string;
  img: string;
}

export const getNoResults = (subRoutes: SubRoute[], locationPathname: string): NoResults => {
  const defaultNoResults: NoResults = {
    title: '',
    msg: '',
    img: '',
  };

  const matchingSubRoute = subRoutes.find(subRoute => subRoute.active.test(locationPathname));

  return matchingSubRoute
    ? {
        title: matchingSubRoute.noResultsTitle,
        msg: matchingSubRoute.noResultsMsg,
        img: matchingSubRoute.noResultsImg,
      }
    : defaultNoResults;
};
